<template>
  <div
    class="modal fade show"
    id="productLink_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    style="display: block; background-color: #11111182; z-index: 999999999"
  >
    <div class="modal-dialog" role="document" style="max-width: 900px">
      <div class="modal-content" style="width: 900px">
        <div class="modal-header">
          <div>
            <h5 class="modal-title">{{ labels.quick_link_products_title }}</h5>
            <span>{{ labels.quick_link_products_subtitle }}</span>
          </div>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="toggleProductLinkModal"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group m-form__group row" style="min-height: 500px">
            <div class="col-lg-12">
              <label for="">{{ labels.products | capitalize }}</label>
              <select
                class="form-control m-choices quick-link-product-choices"
                multiple
              ></select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="toggleProductLinkModal"
          >
            {{ labels.close | capitalize }}
          </button>
          <button type="button" class="btn btn-info" @click="saveAction">
            {{ labels.save }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { HTTP } from "../../../assets/js/axiosConfig";
import Choices from "choices.js";

import algoliaProductsAction from "../../../assets/js/algoliaProductsMixin";
import updateFirestore from "../../../assets/js/mixins";

let productChoices = null;

export default {
  props: ["generalSegmentation", "formProducts"],
  mixins: [algoliaProductsAction, updateFirestore],
  data() {
    return {
      selectedProducts: [],
      segmentation: {
        products: [],
      },
    };
  },
  computed: {
    ...mapState({
      labels: (store) => store.labels,
    }),
  },
  methods: {
    ...mapActions(["setSegmentationProductsToLink", "toggleProductLinkModal"]),
    initProductChoices() {
      var my = this;
      productChoices = new Choices(".quick-link-product-choices", {
        shouldSort: false,
        removeItems: true,
        removeItemButton: true,
        placeholderValue: my.labels["select_from_list"],
        classNames: {
          listDropdown: "list_items_dropdown_custom choices__list--dropdown",
        },
        callbackOnInit() {
          if (my.generalSegmentation[0].products) {
            my.buildProductIdList(
              my.generalSegmentation[0].products,
              null,
              null,
              my.setProductChoices
            );
          }
          this.passedElement.element.addEventListener(
            "addItem",
            function (event) {
              // Add to selected products
              my.selectedProducts.push({
                id: event.detail.value,
                label: event.detail.label,
              });

              // Remove from general-segmentation's products
              var index = my.segmentation.products.indexOf(event.detail.value);
              index !== -1 ? my.segmentation.products.splice(index, 1) : null;
            }
          );

          this.passedElement.element.addEventListener(
            "removeItem",
            function (event) {
              // Remove from selectedProducts []
              var index = my.selectedProducts.indexOf(event.detail.value);
              index !== -1 ? my.selectedProducts.splice(index, 1) : null;

              // Re-add to the general-segmentation's products
              my.segmentation.products.push(event.detail.value);
            }
          );
        },
      });
    },
    setProductChoices(data, dataKey, products) {
      let list = [];
      products.forEach((prod) => {
        if (this.formProducts.indexOf(prod.productId) === -1) {
          list.push({
            value: prod.productId,
            label:
              (prod.brandName || "") +
              ", " +
              (prod.collectionName || "") +
              ", " +
              (prod.name || ""),
            selected: false,
          });
        }
      });
      productChoices.setChoices(list, "value", "label", true);
      return list;
    },
    saveAction() {
      // Close modal
      this.toggleProductLinkModal();
      // Return to child-segmentation form with products to add
      this.setSegmentationProductsToLink(this.selectedProducts);
    },
  },
  mounted() {
    if (this.generalSegmentation.length) {
      this.segmentation = JSON.parse(
        JSON.stringify(this.generalSegmentation[0])
      );
      this.initProductChoices();
    }
  },
};
</script>

<style scoped>
#productLink_modal .list_items_dropdown_custom.choices__list--dropdown {
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CRUDs/Segmentations/ProductLinkModal.vue